module.exports = "/_next/static/images/constructionAndTechnicalManagement-c68ec13a32dc906d67121a4c504e8c74.webp";